export default "__VITE_ASSET__Cff0pCTJ__"